// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"Login_fieldset__30Lta","link":"Login_link__1PqcD","checkbox":"Login_checkbox__1qyZJ"};